import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

import { Translate, Localize, translate, setLocale } from "react-i18nify";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import IdleTimerDisplay from "./../Shared/IdleTimerDisplay_V";

import CharityDonationContent from "./CharityDonationContent";
import CharitySearchContent from "./CharitySearchContent";
import CharitySelectConfirmContent from "./CharitySelectConfirmContent";
import CharitySearchConfirmContent from "./CharitySearchConfirmContent";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import KioskStepper from "./../../Components/Stepper/KioskStepper_V";
import Logo from "./../../Components/Logo_V";

import { useTheme } from "@mui/material/styles";

import { socketEventsHandler } from "./../CustomerPhoneNumber/Shared/socketEventHelper";

import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../../plugin/DeviceID";

import {
  formatNumber,
  extractNumbers
} from "./../CustomerPhoneNumber/Shared/PhoneFormatHelper";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 423:
      return translate("application.errors.webaccessdisabled");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    //errorMessage,
    isNotMobile,
    kioskkey,
    workflowmode,
    getKioskConfiguration
  } = props;

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    qrCode,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);

  const { simplepost } = useContext(HttpContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  //charities, search, selectconfirm, searchconfirm
  const [drawerMenuMode, setDrawerMenuMode] = useState("charities");
  const [selectedCharity, setSelectedCharitiy] = useState({
    name: "default",
    id: null
  });

  const kiosktheme = getKioskTheme();

  useEffect(() => {
    socketEventsHandler(
      socketEvents,
      sessionID,
      setAll,
      setErrorMessage,
      setShowconfirmdialog,
      clearSocketEvents
    );
  }, [socketEvents]);

  //API Version
  const keypadDone = async () => {
    console.log("next called");

    //Commented out just to get a working api for testing
    // let payload = {
    //   type: "REQUESTCUSTOMERINFO",
    //   payload: { type: "phone", value: phonenumber }
    // };

    // sendEvent(payload, () => {
    //   console.log("onEventSent");
    // });

    // return;

    let deviceID = "";
    let serialID = "";

    const deviceIDPluginAvailable = Capacitor.isPluginAvailable("DeviceID");

    if (deviceIDPluginAvailable) {
      const deviceIdValue = await DeviceIDPlugin.get({});
      const serialIdValue = await DeviceIDPlugin.getEloSerial({});

      deviceID = deviceIdValue.androidID;
      serialID = serialIdValue.androidID;
    }

    //Attempt Kiosk Login
    console.log("next called (VL)");

    const res = await simplepost("/kiosk/getCustomer", {
      type: "phone",
      value: extractNumbers(formatNumber(phonenumber, kiosktheme.phoneFormat))
    });

    var customerFirstName = res.data.firstName;
    var customerLastName = res.data.lastName;
    var customerID = res.data.uniqueID;

    if (res.status >= 400) {
      setErrorMessage(displayError(res.status));
      return;
    }

    setAll(
      //customerName, //customerName
      customerFirstName, //customerFirstName
      customerLastName, //customerLastName
      customerID, //customerID
      charityName, //charityName
      charityID, //charityID
      null, //numBags
      null, //numLabels
      null, //labelsList
      sessionID //sessionID
    );

    setErrorMessage("");
    setShowconfirmdialog(true);
  };

  // const backspacepress = async () => {
  //   let newNumber = phonenumber;

  //   if (newNumber.length > 0) {
  //     newNumber = newNumber.substring(0, newNumber.length - 1);
  //   }

  //   setPhonenumber(newNumber);
  // };

  const next = async () => {
    navigate("/numbags");
  };

  const nextWithCharity = async selectedCharity => {
    if (!selectedCharity) {
      return console.error("No Charity Selected!");
    }

    setAll(
      customerFirstName,
      customerLastName,
      customerID, //customerID
      selectedCharity.Title, //charityName
      selectedCharity.id, //charityID
      null, //numBags
      null, //numLabels
      null, //labelsList
      sessionID //sessionID
    );

    navigate("/numbags");
    return;
  };

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  const selectCharityEntity = charityObj => {
    console.log("[selectCharityEntity]");
    setSelectedCharitiy(charityObj);
    setDrawerMenuMode("selectconfirm");
  };

  const selectCharitySearch = charityObj => {
    setSelectedCharitiy(charityObj);
    setDrawerMenuMode("searchconfirm");
  };

  const modeSelectCharity = charityObj => {
    setDrawerMenuMode("charities");
  };

  const modeSearchCharity = charityObj => {
    console.log("[modeSearchCharity]");
    setDrawerMenuMode("search");
  };

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <div style={kioskverticalstyles_2.flexBackground}>
        <div style={kioskverticalstyles_2.logo}>
          <center>
            <Logo />
          </center>
        </div>
        <div style={kioskverticalstyles_2.instructionDiv}>
          <div style={kioskverticalstyles_2.instructionVerticallyAlignDiv}>
            <Translate value="application.theme.charityChooseACharity" />
            <br />
            {drawerMenuMode == "charities" && (
              <div>
                <Translate value="application.theme.charitySelectCharityInstruction" />
              </div>
            )}
            {drawerMenuMode == "search" && (
              <div>
                <Translate value="application.theme.charitySearchCharityInstruction" />
              </div>
            )}
            {drawerMenuMode == "selectconfirm" && (
              <div>
                <Translate value="application.theme.charitySelectCharityInstruction" />
              </div>
            )}
            {drawerMenuMode == "searchconfirm" && (
              <div>
                <Translate value="application.theme.charitySearchCharityInstruction" />
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            ...kioskverticalstyles_2.whiteDiv,
            ...kioskverticalstyles_2.flexcenterDiv
          }}
        >
          {drawerMenuMode == "charities" && (
            <CharityDonationContent
              modeSearchCharity={modeSearchCharity}
              setSelectedCharity={selectCharityEntity}
            />
          )}
          {drawerMenuMode == "search" && (
            <CharitySearchContent setSelectedCharity={selectCharitySearch} />
          )}
          {drawerMenuMode == "selectconfirm" && (
            <CharitySelectConfirmContent
              selectedCharity={selectedCharity}
              cancelFunc={modeSelectCharity}
              confirmCharity={nextWithCharity}
            />
          )}
          {drawerMenuMode == "searchconfirm" && (
            <CharitySearchConfirmContent
              selectedCharity={selectedCharity}
              cancelFunc={modeSelectCharity}
              confirmCharity={nextWithCharity}
            />
          )}
        </div>
        <div style={kioskverticalstyles_2.footerDiv}>
          <KioskStepper
            activeStep={0}
            backUrl={drawerMenuMode == "charities" ? "/language" : undefined}
            backOverwriteFunc={() => {
              if (drawerMenuMode != "charities") {
                setDrawerMenuMode("charities");
              }
            }}
            workflowmode={workflowmode}
            getKioskConfiguration={getKioskConfiguration}
          />
        </div>
      </div>
      <IdleTimerDisplay />
    </IdleTimerProvider>
  );
}
